enum LogsID {
	FRONT_VERSION = 'FRONT_VERSION',
	IMPRESSION_VOLET_EMPLOYEUR = 'IMPRESSION_VOLET_EMPLOYEUR',
	IMPRESSION_RECAP_TRANSMISSION = 'IMPRESSION_RECAP_TRANSMISSION',
	IMPRESSION_CERFA_NON_CONNECTE = 'IMPRESSION_CERFA_NON_CONNECTE',
	IMPRESSION_CERFA_SANS_TRANSMETTRE = 'IMPRESSION_CERFA_SANS_TRANSMETTRE',
	IMPRESSION_CERFA_TRANSMISSION_KO = 'IMPRESSION_CERFA_TRANSMISSION_KO',
	PDF_CHARGE = 'PDF_CHARGE',
	ACCES_FORMULAIRE = 'ACCES_FORMULAIRE',
	ACCES_RECAP_SAISIE_FORMULAIRE = 'ACCES_RECAP_SAISIE_FORMULAIRE',
	ACCES_TRANSMISSION_OK = 'ACCES_TRANSMISSION_OK',
	ACCES_TRANSMISSION_KO = 'ACCES_TRANSMISSION_KO',
	ACCES_LISTE_MOTIFS = 'ACCES_LISTE_MOTIFS',
	RELANCE_TRANSMISSION_KO = 'RELANCE_TRANSMISSION_KO',
	SAISIE_MOTIF_LISTE_MOTIFS = 'SAISIE_MOTIF_LISTE_MOTIFS',
	SAISIE_MOTIF_MANUEL = 'SAISIE_MOTIF_MANUEL',
	SAISIE_MOTIF_MOMENT = 'SAISIE_MOTIF_MOMENT',
	SAISIE_MOTIF_REFERENTIEL = 'SAISIE_MOTIF_REFERENTIEL',
	SAISIE_DUREE_INDICATIVE = 'SAISIE_DUREE_INDICATIVE',
	RETOUR_SUR_PORTAIL_AMELIPRO = 'RETOUR_SUR_PORTAIL_AMELIPRO'
}
export default LogsID;
